import _ from 'lodash';
import { TAction } from '../../../../../../../../shared/frontend/scripts/actions/types/action';
import { actionTypes, actions } from './modules';
import { call, put, takeEvery } from 'redux-saga/effects';
import { apiServiceAsync } from '../../../../services/apiService';

const { FETCH_PROFILE } = actionTypes;

const { loadRecProfileSuccess, loadRecProfileFailure } = actions;

function* fetchRecruitmentProfile(action: TAction<any>): any {
  const { profileId } = action.payload;

  try {
    const { profileData } = yield call(apiServiceAsync.getRecruitmentProfile, profileId);
    yield put(loadRecProfileSuccess(profileData, profileId));
  } catch (e) {
    yield put(loadRecProfileFailure(profileId));
  }
}

function* watchFetchProfile(): any {
  yield takeEvery([FETCH_PROFILE], fetchRecruitmentProfile);
}

export default [watchFetchProfile()];
